import React from 'react'
import injectStyles from 'react-jss'
import { styles } from './styles'

const SimpleButton = ({ classes, onClick, label }) => {
  return (
    <div className={classes.button} onClick={onClick}>
      <div cypress_id={'simpleBtn'}>{label}</div>
    </div>
  )
}

export default injectStyles(styles)(SimpleButton)
